function fnBrands( i, oSection ) {
	const sliders = oSection.querySelectorAll('.swiper')

	sliders.length && sliders.forEach(el => {
		const swiper = new Swiper(el, {
			loop: true,
			spaceBetween: 65,
			slidesPerView: 'auto',
			centeredSlides: true,
			speed: 3000,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
		})
	});
};
